import * as Sentry from '@sentry/react';

import { useSelectTraceSampleRate } from '../../../../configuration';

export const useSentry = () => {
    const tracesSampleRate = useSelectTraceSampleRate();

    Sentry.init({
        dsn: 'https://e728842dd78042cdafc297ae5b2741ae@ase.3plearning.com/24',
        tracesSampleRate
    });
};
